import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { AuthService } from '../../../../../../services/auth.services'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { SharedServices } from '../../../../../../services/shared.services'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { getImageRedirectUrl } from '../../../../../../../helper/common'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import { StateServices } from '../../../../../../services/state.services'
import * as $ from 'jquery'


@Component({
    selector: 'app-modal-client-detail-top-registraion-aligner',
    templateUrl: './modal-client-detail-registraion-aligner.component.html',
    styleUrls: [
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-registraion-aligner.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalClientDetailRegistraionAlignerComponent implements OnInit, OnDestroy {
    en = {}
    showEN = true
    option_RegistrationAligner: String = 'active'
    TabRegistrationAlignerClass
    arrRegistrationAligner: any[] = []
    status: Boolean = false
    url: String = ''
    statusImage: String = ''
    option_Registration: String = 'active'
    senMax: any = 100
    uploadImageForm: FormGroup
    max: any = 5
    arrImageOld
    styleOld
    arrSlideshowTooth
    arrStyleImage = []
    arrTabRegistrationAligner = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: 'Right', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: 'Front', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: 'Left', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: 'Upper', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: 'Overjet', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: 'Lower', nameSave: 'Registration-Tooth-Lower' },
    ]

    arrAllAligner: any[] = []
    jsonAligner: any = {}
    index: any
    arrShowStatus: any[] = []
    tabName: any = 'aligner-all'
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any
    valChange: any = 0
    arrLoading: any[] = []
    matrixImage: any[] = []
    arrImage: any[] = []
    emitTabName: any = {}
    emitArrAll: any = {}
    animationDuration: any

    arrStyle: any[] = [{}, {}, {}, {}, {}, {}]
    isEmptyArray: Boolean = false
    resourceUrl = 'resource'
    countRecrond
    tabUploadImage: any
    ValueAssignOneDistance: any = 0
    @ViewChild('container1') container1: ElementRef
    @ViewChild('imageId1') imageId1: ElementRef
    oldHeight: any
    oldWidth: any

    defaultArrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrIds: any[] = []

    unscrCopy
    unscrIndex
    unscrAllArrClientTop
    unscrArrHash

    getInfoIndex = undefined
    page = 'registration'
    unscrPage


    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices,
                public matrixServices: MatrixServices,
                private stateServices: StateServices) {
        this.option_RegistrationAligner = 'active'
        this.TabRegistrationAlignerClass = 'option_0'
    }

    ngOnInit() {
        this.resetMatrix()
        this.arrLoading = [true, true, true, true, true, true]
        this.uploadImageForm = this.formBuider.group({
            requests: new FormArray([
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
            ]),
        })
        // this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
        const infoTabName: any = this.clientTopServices.functReturnTabName()
        if (infoTabName != null && infoTabName['tabName'] != undefined) {
            this.tabName = infoTabName['tabName']
        } else {
            this.tabName = 'aligner-all'
        }
        const tmpStr: String = this.tabName
        if (tmpStr.includes('aligner')) {
            // this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            this.getArrClientTop()
            // });
        }
        // });

        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })
        if ($(window).innerWidth() != window.screen.width) {
            this.width = ($(window).innerWidth() - 300) / 3
            this.height = 2 * this.width / 3
        } else if ($(window).innerHeight() != window.screen.height) {
            const tmpH = $(window).innerHeight()
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        this.getArrHash()
        this.getStyle()
        this.resizeUser()
        this.resizeFullScreen()
        this.getPage()
    }

    ngOnDestroy() {
        this.getInfoIndex = undefined
        if(this.unscrPage)
            this.unscrPage.unsubscribe()
        if(this.unscrIndex)
            this.unscrIndex.unsubscribe()
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
        if(this.unscrArrHash)
            this.unscrArrHash.unsubscribe()
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }

    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe(screen => {
            if (screen != null && screen != undefined && screen['status'] != undefined) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 200) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 200) / 2
                        this.width = this.height * 3 / 2
                    }
                }
                const _thi = this
                setTimeout(function() {
                    _thi.arrShowStatus.forEach((el, item) => {
                        if (el) {
                            const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                            const imageId: HTMLElement = document.getElementById('imageId' + item)
                            _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationAligner)
                        }
                    })
                }, 10)
            }
        })
    }

    resetMatrix() {
        this.matrixServices.arrRotate = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrStyleImage = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrFlip = [
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
        ]
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            const tmpStr: String = this.tabName
            if (tmpStr.includes('aligner')) {
                if (status != null && status['status'] != undefined) {
                    this.resetMatrix()
                    const tmp: any = status['status']
                    if (tmp == 'in') {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        } else {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        }
                    } else {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 300) / 2
                            this.width = this.height * 3 / 2
                        }
                    }
                    this.oldHeight = this.height
                    this.oldWidth = this.width
                    const _thi = this
                    setTimeout(function() {
                        _thi.arrShowStatus.forEach((el, item) => {
                            if (el) {
                                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                                const imageId: HTMLElement = document.getElementById('imageId' + item)
                                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationAligner)
                            }
                        })
                    }, 10)
                }
            }
        })
    }

    resetMatrixMovedUpPage() {
        const _thi = this
        setTimeout(function() {
            _thi.arrShowStatus.forEach((el, item) => {
                if (el) {
                    const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                    const imageId: HTMLElement = document.getElementById('imageId' + item)
                    if (imageId != undefined && imageWrapper != undefined) {
                        _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationAligner)
                    }
                }
            })
        }, 10)
    }

    getArrClientTop() {
        this.getDataShow()
        this.getDataIndex()
    }

    getDataIndex() {
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            this.arrImageOld = this.arrImage.slice()
            this.styleOld = this.matrixServices.arrStyleImage.slice()
            this.modalService.fadingImage(() => {
                const tmpStr: String = this.tabName
                if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'registration') {
                    this.index = infoIndex['index']
                    this.getInfoIndex = jQuery.extend(true, {}, infoIndex)
                    if (tmpStr.includes('aligner') && this.arrAllAligner.length > 0) {
                        this.max = this.arrAllAligner.length - 1
                        if (this.max > 0) {
                            this.ValueAssignOneDistance = this.senMax / this.max
                            this.valChange = this.index * this.ValueAssignOneDistance
                        } else {
                            this.valChange = 0
                        }
                        this.arrLoading = [false, false, false, false, false, false]
                        if (this.arrAllAligner[this.index] != undefined) {
                            this.jsonAligner = this.arrAllAligner[this.index]
                            this.initjsonAligner(this.arrAllAligner[this.index])
                            this.animationDuration = 300
                        }
                    }
                }
            })
        })
    }

    getDataShow() {
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
            const tmpStr: String = this.tabName
            if (res != null && res['registration'] != undefined && res['registration'].length > 0 && this.page == 'registration') {
                this.isEmptyArray = false
                this.arrAllAligner = res['registration']
                this.countRecrond = res['registration'].length
                if (tmpStr.includes('aligner') && this.getInfoIndex) {
                    if (this.arrAllAligner.length > 0) {
                        this.max = this.arrAllAligner.length - 1
                        if (this.max > 0) {
                            this.ValueAssignOneDistance = this.senMax / this.max
                            this.valChange = this.index * this.ValueAssignOneDistance
                        } else {
                            this.valChange = 0
                        }
                        if (this.arrAllAligner[this.index] != undefined) {
                            this.jsonAligner = this.arrAllAligner[this.index]
                            this.initjsonAligner(this.arrAllAligner[this.index])
                            this.animationDuration = 300
                        }
                    }
                }
            } else {
                this.countRecrond = 0
                this.isEmptyArray = true
                this.arrRegistrationAligner = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrRegistrationAligner)
            }
        })
    }

    getStyle() {
        this.clientTopServices.changeEmittedStyle$.subscribe(style => {
            if (style != null && style['style'] != undefined) {
                const tab: any = style['tabName']
                if (tab == this.tabName) {
                    this.arrStyle = style['style']
                    if (this.arrStyle.length > 0) {
                        this.arrRegistrationAligner = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationAligner)
                        this.jsonAligner[this.tabName] = this.arrRegistrationAligner
                        this.arrAllAligner[this.index] = this.jsonAligner
                        this.emitArrAll['registration'] = this.arrAllAligner
                        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                    } else {
                        const arrCopy: any[] = style['arrCopy']
                        this.arrRegistrationAligner = arrCopy
                        this.getShowStatus(this.arrRegistrationAligner)
                        this.jsonAligner[this.tabName] = this.arrRegistrationAligner
                        this.arrAllAligner[this.index] = this.jsonAligner
                    }
                }
            } else {
                this.arrStyle = [{}, {}, {}, {}, {}, {}]
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != window.screen.width) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 3
            this.height = this.width * 2 / 3
        } else if (event.target.innerHeight != window.screen.height) {
            const tmpH = event.target.innerHeight
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    getArrHash() {
        this.unscrArrHash = this.stateServices.changeEmittedHash$.subscribe(response => {
            if (response != null && response[this.tabName] != undefined && response[this.tabName].length > 0) {
                const tmpStr: String = this.tabName
                const arrRes: any[] = response[this.tabName]
                if (tmpStr.includes('aligner')) {
                    this.arrRegistrationAligner = jQuery.extend(true, [], arrRes)
                    // arrRes.forEach((el, i) => {
                    //     this.arrRegistrationAligner[i] = el;
                    // });
                    this.jsonAligner[this.tabName] = this.arrRegistrationAligner
                    this.arrAllAligner[this.index] = this.jsonAligner
                    const tmp: any = arrRes[0]
                    switch (this.tabName) {
                        case 'aligner-right':
                            this.arrAllAligner[this.index]['aligner-all'][0] = tmp
                            break
                        case 'aligner-front':
                            this.arrAllAligner[this.index]['aligner-all'][1] = tmp
                            break
                        case 'aligner-left':
                            this.arrAllAligner[this.index]['aligner-all'][2] = tmp
                            break
                        case 'aligner-upper':
                            this.arrAllAligner[this.index]['aligner-all'][3] = tmp
                            break
                        case 'aligner-overjet':
                            this.arrAllAligner[this.index]['aligner-all'][4] = tmp
                            break
                        case 'aligner-lower':
                            this.arrAllAligner[this.index]['aligner-all'][5] = tmp
                            break
                        case 'aligner-all':
                            this.arrAllAligner[this.index]['aligner-right'][0] = arrRes[0]
                            this.arrAllAligner[this.index]['aligner-front'][0] = arrRes[1]
                            this.arrAllAligner[this.index]['aligner-left'][0] = arrRes[2]
                            this.arrAllAligner[this.index]['aligner-upper'][0] = arrRes[3]
                            this.arrAllAligner[this.index]['aligner-overjet'][0] = arrRes[4]
                            this.arrAllAligner[this.index]['aligner-lower'][0] = arrRes[5]
                            break
                        default:
                            break
                    }
                    this.emitArrAll['registration'] = this.arrAllAligner
                    this.emitArrAll['checkChange'] = true
                    this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                }
            }
        })
    }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * assignCalculate
            // if (this.arrAllAligner[this.index] != undefined) {
            //     this.jsonAligner = this.arrAllAligner[this.index];
            //     this.initjsonAligner(this.jsonAligner);
            //     this.arrRegistrationAligner = this.jsonAligner[this.tabName];
            // }
            // this.valChange = assign;
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.valChange = 0
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(valueSlider)
        }
    }

    initjsonAligner(json) {
        this.jsonAligner['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonAligner['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonAligner['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonAligner['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonAligner['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonAligner['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonAligner['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.getArrRegistrationAligner(this.jsonAligner)
    }

    getArrRegistrationAligner(arrAligner) {
        this.arrRegistrationAligner = arrAligner[this.tabName]
        this.getShowStatus(this.arrRegistrationAligner)
    }


    swapMatrix(index, nextIndex) {
        const tmp = this.matrixImage[index]
        const swapTmp = this.matrixImage[nextIndex]
        this.matrixImage[index] = swapTmp
        this.matrixImage[nextIndex] = tmp
    }

    swapArrImage(index, nextIndex) {
        const tmp = this.arrImage[index]
        const swapTmp = this.arrImage[nextIndex]
        this.arrImage[index] = swapTmp
        this.arrImage[nextIndex] = tmp
    }

    swapArrImageStyle(index, nextIndex) {
        const tmp = this.arrStyleImage[index]
        const swapTmp = this.arrStyleImage[nextIndex]
        this.arrStyleImage[index] = swapTmp
        this.arrStyleImage[nextIndex] = tmp
    }

    swapArr(index, nextIndex) {
        this.swapMatrix(index, nextIndex)
        this.swapArrImage(index, nextIndex)
        this.swapArrImageStyle(index, nextIndex)
        const tmp = this.arrRegistrationAligner[index]
        const tmpRight = this.arrRegistrationAligner[nextIndex]
        this.arrRegistrationAligner[index] = tmpRight
        this.arrRegistrationAligner[nextIndex] = tmp
        switch (this.TabRegistrationAlignerClass) {
            case 'option_0':
                this.jsonAligner['aligner-all'] = this.arrRegistrationAligner
                let i: any
                let left: any
                let right: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'aligner-right'
                        right = 'aligner-front'
                        break
                    case 2:
                        left = 'aligner-right'
                        i = 'aligner-front'
                        right = 'aligner-left'
                        break
                    case 3:
                        left = 'aligner-front'
                        i = 'aligner-left'
                        right = 'aligner-upper'
                        break
                    case 4:
                        left = 'aligner-left'
                        i = 'aligner-upper'
                        right = 'aligner-overjet'
                        break
                    case 5:
                        left = 'aligner-upper'
                        i = 'aligner-overjet'
                        right = 'aligner-lower'
                        break
                    case 6:
                        left = 'aligner-overjet'
                        i = 'aligner-lower'
                        break
                }
                if (index > nextIndex) {
                    this.jsonAligner[left][0] = tmp
                    this.jsonAligner[i][0] = tmpRight
                } else {
                    this.jsonAligner[i][0] = tmpRight
                    this.jsonAligner[right][0] = tmp
                }
                break
            case 'option_1':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonAligner['aligner-all'][0] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][0] = tmp3
                }
                this.jsonAligner['aligner-right'] = this.arrRegistrationAligner
                break
            case 'option_2':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonAligner['aligner-all'][1] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][1] = tmp3
                }
                this.jsonAligner['aligner-front'] = this.arrRegistrationAligner
                break
            case 'option_3':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonAligner['aligner-all'][2] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][2] = tmp3
                }
                this.jsonAligner['aligner-left'] = this.arrRegistrationAligner
                break
            case 'option_4':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonAligner['aligner-all'][3] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][3] = tmp3
                }
                this.jsonAligner['aligner-upper'] = this.arrRegistrationAligner
                break
            case 'option_5':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonAligner['aligner-all'][4] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][4] = tmp3
                }
                this.jsonAligner['aligner-overjet'] = this.arrRegistrationAligner
                break
            case 'option_6':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonAligner['aligner-all'][5] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][5] = tmp3
                }
                this.jsonAligner['aligner-lower'] = this.arrRegistrationAligner
                break
            default:
                break
        }
        this.arrAllAligner[this.index] = this.jsonAligner
        this.emitArrAll['registration'] = this.arrAllAligner
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationAligner)
    }

    moveRight(index) {
        const nextIndex: any = index + 1
        this.swapArr(index, nextIndex)
    }

    moveLeft(index) {
        const nextIndex: any = index - 1
        this.swapArr(index, nextIndex)
    }

    onDeleteImage(index) {
        this.matrixServices.removePhoto(index)
        const tmpNone: any = {}
        tmpNone['id'] = ''
        this.arrRegistrationAligner[index] = tmpNone
        switch (this.TabRegistrationAlignerClass) {
            case 'option_0':
                this.jsonAligner['aligner-all'] = this.arrRegistrationAligner
                let i: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'aligner-right'
                        break
                    case 2:
                        i = 'aligner-front'
                        break
                    case 3:
                        i = 'aligner-left'
                        break
                    case 4:
                        i = 'aligner-upper'
                        break
                    case 5:
                        i = 'aligner-overjet'
                        break
                    case 6:
                        i = 'aligner-lower'
                        break
                }
                const tmp: any = {}
                tmp['id'] = ''
                this.jsonAligner[i][0] = tmp
                break
            case 'option_1':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonAligner['aligner-all'][0] = tmp1
                }
                this.jsonAligner['aligner-right'] = this.arrRegistrationAligner
                break
            case 'option_2':
                if (index == 0) {
                    const tmp2: any = {}
                    tmp2['id'] = ''
                    this.jsonAligner['aligner-all'][1] = tmp2
                }
                this.jsonAligner['aligner-front'] = this.arrRegistrationAligner
                break
            case 'option_3':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][2] = tmp3
                }
                this.jsonAligner['aligner-left'] = this.arrRegistrationAligner
                break
            case 'option_4':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][3] = tmp3
                }
                this.jsonAligner['aligner-upper'] = this.arrRegistrationAligner
                break
            case 'option_5':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][4] = tmp3
                }
                this.jsonAligner['aligner-overjet'] = this.arrRegistrationAligner
                break
            case 'option_6':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonAligner['aligner-all'][5] = tmp3
                }
                this.jsonAligner['aligner-lower'] = this.arrRegistrationAligner
                break
            default:
                break
        }
        this.uploadImageForm.reset()
        this.matrixServices.removePhoto(index)
        this.arrAllAligner[this.index] = this.jsonAligner
        this.emitArrAll['registration'] = this.arrAllAligner
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationAligner)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.matrixImage = []
        this.arrImage = []
        this.arrStyleImage = []
        if (arr && arr.length > 0) {
            arr.forEach((el, i) => {
                if (el != undefined && el['id'] != undefined && el['id'] != '') {
                    let url
                    if (this.arrayTypeImage[i] != 'other') {
                        url = getImageRedirectUrl(el['id'] + '?type=' + this.arrayTypeImage[i])
                    } else {
                        url = getImageRedirectUrl(el['id'])
                    }
                    this.arrIds[i] = el['id']
                    this.arrImage.push(url)
                    this.arrShowStatus.push(true)
                } else {
                    this.arrImage.push(undefined)
                    this.arrShowStatus.push(false)
                }
                if (el != undefined && el['matrix'] != undefined) {
                    this.matrixImage.push(el['matrix'])
                } else {
                    this.matrixImage.push([1, 0, 0, 1])
                }
                if (el != undefined && el['style'] != undefined) {
                    this.arrStyleImage.push(el['style'])
                } else {
                    this.arrStyleImage.push({})
                }
            })
            this.getStyleMatrix(this.matrixImage, this.arrImage, this.arrRegistrationAligner)
        }
        // this.resetMatrixMovedUpPage();
    }

    getStyleMatrix(matrixImage, arrImage, arrRegistration) {
        const _thi = this
        setTimeout(() => {
            arrRegistration.forEach(function(el, item) {
                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                const imageId: HTMLElement = document.getElementById('imageId' + item)
                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, matrixImage, arrImage, arrRegistration)
            })
        }, 200)
    }

    toggleTabRegistrationAlignerItem(id, event) {
        this.uploadImageForm.reset()
        this.TabRegistrationAlignerClass = id
        switch (id) {
            case 'option_0':
                this.tabName = 'aligner-all'
                break
            case 'option_1':
                this.tabName = 'aligner-right'
                break
            case 'option_2':
                this.tabName = 'aligner-front'
                break
            case 'option_3':
                this.tabName = 'aligner-left'
                break
            case 'option_4':
                this.tabName = 'aligner-upper'
                break
            case 'option_5':
                this.tabName = 'aligner-overjet'
                break
            case 'option_6':
                this.tabName = 'aligner-lower'
                break
            default:
                this.tabName = 'aligner-all'
                break
        }
        this.emitTabName['tabName'] = this.tabName
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.arrRegistrationAligner = this.jsonAligner[this.tabName]
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrRegistrationAligner)
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined !== this.arrRegistrationAligner && this.arrRegistrationAligner.length > 0) {
                const tmp: any = this.arrRegistrationAligner[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    setArrClientTop(data, index, idImage) {
        this.arrRegistrationAligner = data
        this.getShowStatus(this.arrRegistrationAligner)
        switch (this.tabUploadImage) {
            case 'option_0':
                this.jsonAligner['aligner-all'] = data

                let i: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'aligner-right'
                        break
                    case 2:
                        i = 'aligner-front'
                        break
                    case 3:
                        i = 'aligner-left'
                        break
                    case 4:
                        i = 'aligner-upper'
                        break
                    case 5:
                        i = 'aligner-overjet'
                        break
                    case 6:
                        i = 'aligner-lower'
                        break
                }
                const tmp: any = idImage
                this.jsonAligner[i][0] = tmp
                break
            case 'option_1':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonAligner['aligner-all'][0] = tmp3
                }
                this.jsonAligner['aligner-right'] = data
                break
            case 'option_2':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonAligner['aligner-all'][1] = tmp3
                }
                this.jsonAligner['aligner-front'] = data
                break
            case 'option_3':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonAligner['aligner-all'][2] = tmp3
                }
                this.jsonAligner['aligner-left'] = data
                break
            case 'option_4':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonAligner['aligner-all'][3] = tmp3
                }
                this.jsonAligner['aligner-upper'] = data
                break
            case 'option_5':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonAligner['aligner-all'][4] = tmp3
                }
                this.jsonAligner['aligner-overjet'] = data
                break
            case 'option_6':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonAligner['aligner-all'][5] = tmp3
                }
                this.jsonAligner['aligner-lower'] = data
                break
            default:
                break
        }
        this.arrAllAligner[this.index] = this.jsonAligner
        this.emitArrAll['registration'] = this.arrAllAligner
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
    }

    uploadFileEnd(event) {
        this.tabUploadImage = this.TabRegistrationAlignerClass
        this.clientTopServices.checkChangeData = true
        const jsonFlip: any = {
            'horizontalFlip': 1,
            'verticalFlip': 1,
        }
        const i = event.item
        this.matrixServices.arrFlip[i] = jsonFlip
        const tmp: any = {}
        tmp['id'] = event.success['hash']
        tmp['matrix'] = [1, 0, 0, 1]
        this.arrRegistrationAligner[i] = tmp
        this.matrixImage[i] = [1, 0, 0, 1]
        const url = getImageRedirectUrl(event.success['hash'])
        this.arrImage[i] = url
        this.setArrClientTop(this.arrRegistrationAligner, i, tmp)
        this.arrLoading[i] = false
    }

    onStartUpload(event) {
        let listUpload: any[] = event.listUpload
        this.animationDuration = event.animationDuration
        const arrLenghtImageFile = event.arrLenghtImageFile
        for (let index = 0; index < listUpload.length; index++) {
            if (listUpload[index] && arrLenghtImageFile > index) {
                this.arrLoading[listUpload[index]] = true
            }
        }
    }

    onUploadError() {
        this.uploadImageForm.reset()
        //Todo notify file error if have
    }

    handleFileInput(files: FileList, index, event) {
        if (event.target.files && event.target.files[0]) {
            this.tabUploadImage = this.TabRegistrationAlignerClass
            const arrUploadImage: any[] = this.arrRegistrationAligner
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0])
            const excrptFile: any = 'image/'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                this.animationDuration = 2800
                this.arrLoading[index] = true
                reader.onload = (event: any) => {
                    this.url = event.target.result
                    this.arrShowStatus[index] = true
                    this.getUrlImage(0, event.target.result)
                }
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            const jsonFlip: any = {
                                'horizontalFlip': 1,
                                'verticalFlip': 1,
                            }
                            this.matrixServices.arrFlip[index] = jsonFlip
                            const tmp: any = {}
                            tmp['id'] = success['hash']
                            tmp['matrix'] = [1, 0, 0, 1]
                            arrUploadImage[index] = tmp
                            this.arrLoading[index] = false
                            this.matrixImage[index] = [1, 0, 0, 1]
                            const url = getImageRedirectUrl(success['hash'])
                            this.arrImage[index] = url
                            this.setArrClientTop(arrUploadImage, index, tmp)
                            this.resetFile(index)
                        },
                    )
                })
            } else {
                this.uploadImageForm.reset()
            }
        } else {
            this.uploadImageForm.reset()
        }
    }

    resetFile(item) {
        $('#fileUpload_' + item).val('');
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/registration/registrationAligner/modal-client-detail-registraion-aligner.component.ts